import React, { useState } from 'react';
import Card from "react/components/Card";
import Chevron from "react/elements/Chevron";

export default function ExpandableCard({
	                                       cardTitle,
	                                       expanded: expandedDefault = true,
	                                       manageExpansion = true,
	                                       children,
	                                       toggleableOnlyOnChevron = undefined,
	                                       ...props
                                       }) {

	const [expanded, setExpanded] = useState(expandedDefault);

	const onClick = () => {
		setExpanded((current) => {
			return !current;
		});
	};
	let wholeTitleClick = undefined;
	let chevronClick = undefined;
	if(toggleableOnlyOnChevron) {
		chevronClick = onClick;
	} else {
		wholeTitleClick = onClick;
	}

	return (
		<Card
			children={expanded && children}
			cardTitle={
				<div
					onClick={wholeTitleClick}
					className={`flexed ${wholeTitleClick ? 'clickable' : ''}`}>
					{cardTitle}
					<div className="end">
						<Chevron
							className={`${chevronClick ? 'clickable' : ''}`}
							onClick={chevronClick}
							expanded={expanded}
						/>
					</div>
				</div>
			}
			{...props}
		/>
	);
}